import type { TeamMember } from "@/types/domain";

/** 团队成员；role/program/focus/statement 走 i18n（TeamPage:members.<id>.*） */
export const TEAM_MEMBERS: TeamMember[] = [
  { id: "jiaming", name: "Jiaming Han", domain: "business", leadership: true },
  { id: "lucas", name: "Lucas Lyu", domain: "software", leadership: true },
  { id: "fengwe", name: "Fengwei Huang", domain: "software", coordinator: true },
  { id: "younger", name: "Younger", domain: "software" },
  { id: "daniel", name: "Daniel Wu", domain: "software" },
  { id: "yuzhe", name: "Yuzhe Ji", domain: "electrical", groupLead: true },
  { id: "zongyu", name: "Zongyu He", domain: "electrical" },
  { id: "xuan", name: "Xuan Yin", domain: "electrical" },
  { id: "harris", name: "Harris Liu", domain: "electrical" },
  { id: "crown", name: "Crown Zhang", domain: "mechanical", groupLead: true },
  { id: "tianyu", name: "Tianyu Wu", domain: "mechanical" },
  { id: "haoxuan", name: "Haoxuan Liu", domain: "mechanical" },
  { id: "alice", name: "Alice Liu", domain: "business", groupLead: true },
  { id: "minal", name: "Minal Rehan", domain: "business" },
  { id: "jane", name: "Jane Nguyen", domain: "business" },
  { id: "max", name: "Max Li", domain: "business" },
];
